

















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";

interface IAudiobookName {
  [key: string]: string;
}

interface IAudiobookAuthor {
  name: string;
  ru?: string;
  en?: string;
  [key: string]: string | undefined;
}

interface IAudiobook {
  _id: string;
  name: IAudiobookName;
  length: number;
  author?: IAudiobookAuthor[];
  narrator?: IAudiobookAuthor[];
  src?: {
    file?: unknown[];
    vertical_poster?: { [key: string]: string };
  };
  show: boolean;
}

@Component({ components: { BSwitch, BSettingDd } })
class AudiobookTableCard extends Vue {
  @Prop({ type: Object, default: null }) book!: IAudiobook;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  posterError = false;

  get getPoster(): string {
    const poster = this.book.src?.vertical_poster;
    if (!poster) return "";
    return poster[this.$i18n.locale] || poster.ru || poster.en || "";
  }

  get showPoster(): boolean {
    return !!this.getPoster && !this.posterError;
  }

  @Watch("getPoster")
  onPosterChange(): void {
    this.posterError = false;
  }

  get localizedName(): string {
    const name = this.book.name;
    return name ? name[this.$i18n.locale] || name.ru || name.en || "—" : "—";
  }

  get authors(): string {
    return this.formatNames(this.book.author);
  }

  get narrators(): string {
    return this.formatNames(this.book.narrator);
  }

  get chaptersCount(): number {
    return (
      (this.book.src && this.book.src.file && this.book.src.file.length) || 0
    );
  }

  get duration(): string {
    return this.formatDuration(this.book.length);
  }

  formatNames(authors: IAudiobookAuthor[] | undefined): string {
    if (!authors || !authors.length) return "—";
    return authors
      .map((a) => a[this.$i18n.locale] || a.ru || a.en || a.name)
      .join(", ");
  }

  formatDuration(seconds: number | undefined): string {
    if (!seconds) return "—";
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    if (h > 0) {
      return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    }
    return `${m}:${String(s).padStart(2, "0")}`;
  }
}
export default AudiobookTableCard;
